__webpack_require__._mf_l = (    function loadScript(remoteEntryUrl, remoteGlobalName) {
        return new Promise((resolve, reject) => {
            if (typeof __webpack_require__.g[remoteGlobalName] !== 'undefined') {
                return resolve(__webpack_require__.g[remoteGlobalName]);
            }
            __webpack_require__.l(
                remoteEntryUrl,
                async function(event) {
                    if (typeof __webpack_require__.g[remoteGlobalName] !== 'undefined') {
                        // await & re-assign to handle remotes loaded via patched webpack_exec,
                        // this support both normal & promise container as await handles both.
                        var container = __webpack_require__.g[remoteGlobalName];
                        __webpack_require__.g[remoteGlobalName] = await container;
                        return resolve(__webpack_require__.g[remoteGlobalName]);
                    }
                    var errorType = event && (event.type === 'load' ? 'missing' : event.type);
                    var realSrc = event && event.target && event.target.src;
                    var __webpack_error__ = new Error();
                    __webpack_error__.message = 'MF: Loading script failed.\n(' + errorType + ': ' + realSrc + ')';
                    __webpack_error__.name = 'ScriptExternalLoadError';
                    __webpack_error__.type = errorType;
                    __webpack_error__.request = realSrc;
                    reject(__webpack_error__);
                },
                remoteGlobalName,
            );
        }).then((remoteContainer) => {
        const proxy = {
            get: remoteContainer.get.bind(remoteContainer),
            init: async (sharedScope) => {
                if (remoteContainer.__initialized || remoteContainer.__initializing) return;
                remoteContainer.__initializing = true;
                try {
                    // share scope: mark deps from host as "loaded" to trick Webpack,
                    // making it choose shared deps from current host instead of remotes
                    Object.values(sharedScope).forEach((ver) => {
                        Object.keys(ver).forEach((k) => {
                            if (ver[k].from === "web-app") {
                                ver[k].loaded = 1;
                            }
                        });
                    });
                    await remoteContainer.init(sharedScope);
                    remoteContainer.__initialized = true;
                } catch (err) {
                } finally { remoteContainer.__initializing = false; }
            },
        };
        return proxy;
    });
    });